import { Asset } from '../../../queries/ats/titles/types/asset';

export function getPurchaseModalTitleName(focusedAsset: Asset) {
  const { titleName, type, series, season, episode } = focusedAsset;

  if (type === 'episode' && series && season && episode) {
    return `${series.titleName} - S${season.sequenceNumber} E${episode.sequenceNumber}`;
  }

  return titleName;
}
